import KeenSlider from "keen-slider";

let dots;

const navigation = (slider) => {
	const leftBtn = document.querySelectorAll(
		".global-50-50-carousel__slider-controls [data-dir=left]"
	);
	const rightBtn = document.querySelectorAll(
		".global-50-50-carousel__slider-controls [data-dir=right]"
	);

	leftBtn.forEach((button) => {
		button.addEventListener("click", slider.prev);
	});

	rightBtn.forEach((button) => {
		button.addEventListener("click", slider.next);
	});
};

export default function () {
	if (document.querySelector("[data-global-50-50-carousel]")) {
		new KeenSlider(
			"[data-global-50-50-carousel]",
			{
				loop: true,
				slides: {
					perView: 1,
				},
			},
			[navigation]
		);
	}
}
